export default "__VITE_ASSET__BF0ayl8G__"